import api from "../config/api";
import { LeaveRequest } from "../types/LeaveRequest";

const API_URL = "/leaveRequest";

export const getLeaveRequests = () =>
  api.get(`${API_URL}/`).then((res) => res.data.data);

export const getLeaveRequestById = (id: number) =>
  api.get(`${API_URL}/?id=${id}`);

export const createLeaveRequest = (data: LeaveRequest) =>
  api.post(`${API_URL}/`, data);

export const updateLeaveRequest = (id: number, data: LeaveRequest) =>
  api.put(`${API_URL}/?id=${id}`, data);

export const updateStatusLeaveRequest = (id: number, data: LeaveRequest) =>
  api.put(`${API_URL}/?id=${id}&action=update-status`, data);

export const deleteLeaveRequest = (id: number) =>
  api.delete(`${API_URL}/?id=${id}`);
